<template>
  <div class="h-[calc(100vh-66px)] bg-white flex flex-col justify-center items-center">
    <div class="gray">
      <div class="flex w-fit justify-start pl-20"><snap-logo product="snap-logo-store" white="false" variant="1line"></snap-logo></div>
      <div class="flex justify-self-center justify-center items-center gap-30 pt-14 pl-20 pr-[75px] w-fit">
        <div class="text-[#051C31] font-bold font-inter text-4xl leading-[50px] md:w-[461px]">
          Thanks for your submission. Our team will be reaching out to you upon receiving your submission
          <p class="text-sm font-medium text-[#051C31]">Stores may take anywhere from 10-15 business days to create.</p>
        </div>
        <div class="ml-10">
          <img id="lead-form-image" :src="betaFormImage" alt="betaFormImage" />
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import betaFormImage from "@/assets/images/lead-form-image.svg";
</script>
